const stripeCurrencyFormatter = (data) => {
    return (data.amount / 100).toLocaleString(data.currency, {
      style: "currency",
      currency: data.currency,
    });
  };


export { stripeCurrencyFormatter }